import type { IChipItem } from "pro-features/components/MultiChipDown/src/MultiChipDownTypes";
import type { ActivationObjectSchema } from "app/pages/activation/types/api";

export enum DropdownOptionListType {
    SELECT_ALL,
    DOMAIN,
    PROJECT,
}
export interface IChipItemWithOptionType extends IChipItem {
    type: DropdownOptionListType;
    sharedBy?: string;
}
export interface IDomains {
    Name: string;
    Favicon: string;
}

export interface IDomainsFilterProps {
    activationSets: ActivationObjectSchema[];
    domainsFilterData: IDomains[];
}

export interface IDomainsList {
    id: string;
    text: string;
    imageUrl?: string;
    type: DropdownOptionListType;
}
